import {languageModule, studyDefinitionModule} from "@/store";
import {Vue} from "vue-property-decorator";
import {findEnumValue} from "@/auxillary/enum.lookup";

export const translate = function (
    displayKey: string | undefined,
    scope?: string,
    parameters?: { [key: string]: string } | undefined): string {
    if (displayKey === undefined)
        return "";
    const text = languageModule.translate(
        displayKey,
        "de",
        studyDefinitionModule.studyDefinition.id,
        scope)
    return interpolate(text, parameters);
}

// Replaces {placeholder} tokens in a resolved text with the supplied parameter values.
// Unknown tokens are left untouched so missing params are visible instead of silently dropped.
export const interpolate = function (
    text: string,
    parameters?: { [key: string]: string } | undefined): string {
    if (!parameters)
        return text;
    return text.replace(/\{(\w+)\}/g, (match, key) =>
        Object.prototype.hasOwnProperty.call(parameters, key) ? parameters[key] : match);
}

export const translateFilter = Vue.filter('translate', translate);

export const translateEnum = function (enumIdentifier: string, code: string) {
    const enumValue = findEnumValue(enumIdentifier, code);
    if (enumValue?.displayKey) {
        return translate(enumValue.displayKey)
    }
    return code;
}